import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "card-title mt-0" }
const _hoisted_4 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_5 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_6 = { class: "col-10" }
const _hoisted_7 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_8 = { class: "col-10" }
const _hoisted_9 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_10 = { class: "col-10" }
const _hoisted_11 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_12 = { class: "col-10" }
const _hoisted_13 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_14 = { class: "col-10" }
const _hoisted_15 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_16 = { class: "col-9" }
const _hoisted_17 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_18 = { class: "col-10" }
const _hoisted_19 = {
  key: 1,
  class: "row mr-3 ml-3 v-theme--light"
}
const _hoisted_20 = { class: "col-10" }
const _hoisted_21 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_22 = { class: "col-10" }
const _hoisted_23 = {
  key: 2,
  class: "mr-3 ml-3 v-theme--light"
}
const _hoisted_24 = { class: "row pl-4 d-flex align-items-center" }
const _hoisted_25 = { class: "col-7 col-md-2" }
const _hoisted_26 = { class: "pt-2" }
const _hoisted_27 = { class: "col-5 col-md-10 pt-0 pb-0" }
const _hoisted_28 = { class: "form-footer p-2" }

import ManagementOfficeAutoComplete from '@/components/AutoCompletes/ManagementOfficeAutoComplete.vue';
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import DepartmentAutoComplete from '@/components/AutoCompletes/DepartmentAutoComplete.vue';
import DigitacoMappingAutoComplete from '@/components/VehicleFormParts/DigitacoMappingAutoComplete.vue';
import DigitalTacographFWCopyAutoComplete from '@/components/VehicleFormParts/DigitalTacographFWCopyAutoComplete.vue';
import IniFileSetting from '@/components/VehicleFormParts/IniFileSetting.vue';
import Api from '@/services/api/ApiServiceFabrick';
import AuthorityCacheApi from '@/services/models/AuthorityCacheApi';
import { useAuth } from '@/services/user/Auth0UserProvider';
import { ObjectToFormData, deleteParams, firstFile } from '@/services/functions';
import { scrollToErrorComponent } from '@/services/validators';
import i18n from '@/lang/i18n';
import VehicleTabs from '@/components/VehicleTabs.vue';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  MANAGEMENT_OFFICE_TYPE,
  SUB_MANAGEMENT_OFFICE_TYPE,
  OPERATION_OFFICE_TYPE,
  DEPARTMENT_OFFICE_TYPE,
  INSTALLATION_OFFICE_TYPE,
  TELTONIKA_DEVICE_TYPE_IDS,
} from '@/services/consts';
import VehicleVerifyImage from '@/components/VehicleFormParts/VehicleVerifyImage.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ManageVehicleForm',
  props: {
    showFlash: { type: Function },
    switchContentLoading: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const router = useRouter();
const { loginWithRedirect } = useAuth();

const form = ref<any>({
  parameters: {},
  is_daily_report_job_disabled: false,
});
const initialModel = ref<any>(null);
const isCreating = ref(false);
const title = ref('');
const errors = ref<any>({});
const vehicle_verify_image = ref<File | File[] | null>([]);
const selfOfficeType = ref<string | null>(null);
const digitalTacographFWCopyId = ref<any>(null);
const vehicleForm = ref<any>(null);
const showableUpdateButton = ref(false);
const isAuthority = ref(false);
const loaded = ref(false);
const running = ref(false);
const simType = ref<string | null>(null);
const accessPoint = ref<string | null>(null);
const isOperationOffice = ref(false);
const isManagementOffice = ref(false);
const isSubManagementOffice = ref(false);
const isInstallationOffice = ref(false);
const isLatestStatus = ref(true);
const configHash = ref<string | null>(null);
const initialOperationId = ref<number | undefined>(undefined);
const initialManagementId = ref<number | undefined>(undefined);
const initialManagementType = ref<string | undefined>(undefined);
const initialDepartmentId = ref<number | null | undefined>(undefined);
const initialDigitacoMappingId = ref<number | undefined>(undefined);
const initialDigitalTacographFWCopyId = ref<any>(undefined);
const deletekeys = ['operationOffice', 'managementOffice', 'sim', 'ini_file'];
const hasError = ref(false);
const hasItemError = ref(false);
const isDigitacoMappingClicked = ref(false);
const isRemoveVerifyImg = ref(false);

const operationOffices = computed(() => {
  if (form.value.operationOffice) return [form.value.operationOffice];
  return [];
});

const managementOfficeClearable = computed(() => {
  return !isSubManagementOffice.value && !isOperationOffice.value;
});

const operationOfficeClearable = computed(() => {
  return !isOperationOffice.value;
});

const routeVehicleId = computed<number | null>(() => {
  const idParam = route.params.id;
  if (!idParam) return null;
  const normalized = Array.isArray(idParam) ? idParam[0] : idParam;
  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? null : parsed;
});

const isSelectedTeltonikaDevice = computed(() => {
  if (form.value.digital_tacograph === null || form.value.digital_tacograph === undefined) {
    return false;
  } else if (typeof form.value.digital_tacograph === 'number' && form.value.device?.id) {
    return TELTONIKA_DEVICE_TYPE_IDS.includes(form.value.device?.model_type);
  }

  return TELTONIKA_DEVICE_TYPE_IDS.includes(form.value.digital_tacograph?.model_type);
});

const isDisplayIniFileSetting = computed(() => {
  return vehicleForm.value && !isSelectedTeltonikaDevice.value;
});

function changeAccessPointToSpace(targetAccessPoint: string | null) {
  switch (targetAccessPoint) {
    case 'BridgeDocomap':
      return 'Bridge docomap';
    case 'IoTCore':
      return 'IoT Core';
    case 'IoTGW':
      return 'IoT GW';
    default:
      return targetAccessPoint;
  }
}

function changeAccessPointToUpperCamelCase(targetAccessPoint: string | null) {
  switch (targetAccessPoint) {
    case 'Bridge docomap':
      return 'BridgeDocomap';
    case 'IoT Core':
      return 'IoTCore';
    case 'IoT GW':
      return 'IoTGW';
    default:
      return targetAccessPoint;
  }
}
function removeImage() {
  form.value.vehicle_verify_image = [];
  vehicle_verify_image.value = [];
  isRemoveVerifyImg.value = true;
}

function setSimAndAccessPoint(data: any) {
  simType.value = data?.sim ?? null;
  accessPoint.value = changeAccessPointToSpace(data?.access_point) ?? null;
}

function compareHash(compareParams: any) {
  if (!simType.value || !accessPoint.value) {
    return true;
  }
  const simAndAccessPoint = `${simType.value}.${changeAccessPointToUpperCamelCase(accessPoint.value)}`;
  const latestConfigHash = vehicleForm.value?.default_params?.[simAndAccessPoint]?.['config_hash'];
  return latestConfigHash == compareParams;
}

function changeSimType(val: string) {
  if (simType.value != val) isLatestStatus.value = true;
  simType.value = val;
}

function changeAccessPoint(val: string) {
  if (accessPoint.value != val) isLatestStatus.value = true;
  accessPoint.value = val;
}

function changeIsLatestStatus(bool: boolean) {
  isLatestStatus.value = bool;
}

function updateConfigHash(val: string) {
  if (isLatestStatus.value) configHash.value = val;
}

function makeParams() {
  const {
    operationOffice,
    managementOffice,
    digital_tacograph,
    digital_tacograph_FW_copy,
    department,
  } = form.value;

  let preparedFormData = {
    ...JSON.parse(JSON.stringify(form.value)),
    operation_office_id: operationOffice?.id,
    management_officeable_id: managementOffice?.id,
    management_officeable_type: managementOffice?.type,
    sim_type: simType.value,
    access_point: changeAccessPointToUpperCamelCase(accessPoint.value),
    config_hash: configHash.value,
    digital_tacograph: digital_tacograph?.id ?? digital_tacograph ?? '',
    department_id: department?.id ?? '',
    is_remove_verify_img: isRemoveVerifyImg.value,
  } as any;

  if (operationOffice?.tdsensor === false) {
    preparedFormData.parameters.tdsensor.tdrfsensor = 'OFF';
  }

  if (digital_tacograph_FW_copy) {
    preparedFormData.digital_tacograph_FW_copy = digital_tacograph_FW_copy.id;
  }
  if (preparedFormData.parameters?.tdsensor?.sensor_setting) {
    preparedFormData.sensor_setting = preparedFormData.parameters.tdsensor.sensor_setting;
    delete preparedFormData.parameters.tdsensor.sensor_setting;
  }

  preparedFormData = deleteParams(preparedFormData, deletekeys);
  Object.keys(preparedFormData?.parameters?.speed_alert ?? {}).forEach((key) => {
    if (typeof preparedFormData.parameters.speed_alert[key] === 'number') {
      preparedFormData.parameters.speed_alert[key] = preparedFormData.parameters.speed_alert[key].toString();
    }
  });

  const formData = new FormData();
  const verifyImage = firstFile(vehicle_verify_image.value);
  if (verifyImage) {
    formData.append('img', verifyImage);
  }

  ObjectToFormData(preparedFormData, formData, '');

  const machineId = digital_tacograph?.name ?? '';
  formData.set('parameters[common][machine_id]', machineId);

  return formData;
}

function submit() {
  running.value = true;
  const params = makeParams();

  Api()
    .createOrUpdateVehicle(routeVehicleId.value, params as any)
    .then(() => {
      props.showFlash?.(i18n.global.t('pages.common.messages.success'), 'success', true);
      running.value = false;
      router.push('/vehicles');
    })
    .catch((error) => {
      const res = error.response;
      switch (res.status) {
        case 401:
          loginWithRedirect({
            appState: { targetUrl: location.pathname },
          });
          break;
        case 403:
          location.reload();
          break;
        case 422:
          errors.value = res.data.errors;
          scrollToErrorComponent();
      }
      running.value = false;
    });
}

async function getItem() {
  if (!routeVehicleId.value) {
    loaded.value = true;
    showableUpdateButton.value = true;
    props.switchContentLoading?.(false);
    return;
  }
  await Api()
    .getVehicle(routeVehicleId.value)
    .then((data) => {
      if (!data.id) {
        loaded.value = true;
        return router.push('/vehicles/form');
      }
      form.value = data;
      if (form.value?.parameters?.device) {
        form.value.parameters.device.mqtt_cid = '';
      }

      form.value.operationOffice = {
        id: data.operation_office_id,
      };
      form.value.managementOffice = {
        id: data.management_officeable_id,
        type: data.management_officeable_type,
      };
      initialDepartmentId.value = data.department_id;
      initialModel.value = JSON.parse(JSON.stringify(form.value));
      initialManagementId.value = data.management_officeable_id;
      initialManagementType.value = data.management_officeable_type;
      initialOperationId.value = form.value.operationOffice.id;
      initialDigitacoMappingId.value = form.value.digital_tacograph;
      initialDigitalTacographFWCopyId.value = (data as any).digital_tacograph_FW_copy;
      digitalTacographFWCopyId.value = form.value.digital_tacograph_FW_copy;
      setSimAndAccessPoint(form.value);
      configHash.value = form.value.config_hash;
      isLatestStatus.value = compareHash(configHash.value);
    });
  loaded.value = true;
  showableUpdateButton.value = true;
  props.switchContentLoading?.(false);
}

function getVehicleForm() {
  Api()
    .getVehicleForm()
    .then((data) => {
      vehicleForm.value = data;
      getItem();
    });
}

function clearFormField(field: string) {
  form.value[field] = '';
}

watch(() => form.value.digital_tacograph_FW_copy, () => {
  const id = form.value?.digital_tacograph_FW_copy?.id ?? form.value?.digital_tacograph_FW_copy;
  if (id == digitalTacographFWCopyId.value) {
    return;
  }
  digitalTacographFWCopyId.value = id;
  if (!form.value.digital_tacograph_FW_copy?.vehicle) {
    return;
  }

  const beforeMqttCid = form.value?.parameters?.device?.mqtt_cid;
  form.value.parameters = form.value.digital_tacograph_FW_copy.vehicle.parameters;
  if (form.value?.parameters?.device) {
    form.value.parameters.device.mqtt_cid = beforeMqttCid;
  }
  setSimAndAccessPoint(form.value.digital_tacograph_FW_copy.vehicle);
  configHash.value = form.value.digital_tacograph_FW_copy.vehicle.config_hash;
  isLatestStatus.value = compareHash(configHash.value);
}, { deep: true });

watch(() => form.value.digital_tacograph, () => {
  if (!form.value?.parameters?.common) {
    return;
  }
  form.value.parameters.common.machine_id = form.value.digital_tacograph?.name;
}, { deep: true });

onMounted(() => {
  props.switchContentLoading?.(true);
  isCreating.value = !routeVehicleId.value;
  title.value = isCreating.value
    ? i18n.global.t('pages.vehicles.title.create')
    : i18n.global.t('pages.vehicles.title.edit');
  document.title = title.value;

  Api().getSelfAccount().then((data) => {
    selfOfficeType.value = data?.login_organization_type ?? null;
    isOperationOffice.value =
      selfOfficeType.value == OPERATION_OFFICE_TYPE ||
      selfOfficeType.value == DEPARTMENT_OFFICE_TYPE;
    isManagementOffice.value = selfOfficeType.value == MANAGEMENT_OFFICE_TYPE;
    isSubManagementOffice.value = selfOfficeType.value == SUB_MANAGEMENT_OFFICE_TYPE;
    isInstallationOffice.value = selfOfficeType.value == INSTALLATION_OFFICE_TYPE;
  });

  AuthorityCacheApi.getWithParse().then((authorityList) => {
    if (isCreating.value) {
      isAuthority.value = !!authorityList['octlink.vehicle.create'];
    } else {
      isAuthority.value = !!authorityList['octlink.vehicle.update'];
    }
    if (!authorityList['octlink.vehicle.read']) {
      router.push('/');
    }
  });

  getVehicleForm();
});

onBeforeUnmount(() => {
  props.switchContentLoading?.(false);
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isManagementOffice.value || isSubManagementOffice.value || isInstallationOffice.value)
        ? (_openBlock(), _createBlock(VehicleTabs, {
            key: 0,
            class: "mb-4"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("h4", _hoisted_3, _toDisplayString(title.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-5", 
            !errors.value.managementOffice || errors.value.managementOffice?.length == 0
              ? ''
              : 'error'
          ])
        }, [
          _createVNode(ManagementOfficeAutoComplete, {
            modelValue: form.value.managementOffice,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.managementOffice) = $event)),
            "error-messages": errors.value.management_officeable_id,
            selectFirstIfOnlyOne: "",
            initialManagementId: initialManagementId.value,
            initialManagementType: initialManagementType.value,
            clearable: managementOfficeClearable.value,
            disabled: isInstallationOffice.value
          }, null, 8, ["modelValue", "error-messages", "initialManagementId", "initialManagementType", "clearable", "disabled"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-5", 
            !errors.value.operationOffice || errors.value.operationOffice?.length == 0
              ? ''
              : 'error'
          ])
        }, [
          _createVNode(SingleOperationOfficeAutoComplete, {
            label: _unref(i18n).global.t('pages.vehicles.operationOffice'),
            modelValue: form.value.operationOffice,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.operationOffice) = $event)),
            managementOffice: form.value.managementOffice,
            "error-messages": errors.value.operation_office_id,
            selectFirstIfOnlyOne: "",
            initialOperationId: initialOperationId.value,
            clearable: operationOfficeClearable.value,
            disabled: isInstallationOffice.value
          }, null, 8, ["label", "modelValue", "managementOffice", "error-messages", "initialOperationId", "clearable", "disabled"])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(VehicleVerifyImage, {
            modelValue: vehicle_verify_image.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((vehicle_verify_image).value = $event)),
            form: form.value,
            modelId: form.value.id,
            errors: errors.value,
            isInstallationOffice: isInstallationOffice.value,
            onRemoveImage: removeImage
          }, null, 8, ["modelValue", "form", "modelId", "errors", "isInstallationOffice"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_text_field, {
            class: "pt-2",
            modelValue: form.value.frames_number,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.frames_number) = $event)),
            "error-messages": errors.value.frames_number,
            disabled: isInstallationOffice.value,
            clearable: "",
            "onClick:clear": _cache[4] || (_cache[4] = ($event: any) => (clearFormField('frames_number')))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicles.framesNumber')) + " ", 1),
              _cache[19] || (_cache[19] = _createElementVNode("span", { style: {"color":"red"} }, [
                _createElementVNode("strong", null, "*")
              ], -1))
            ]),
            _: 1
          }, 8, ["modelValue", "error-messages", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_text_field, {
            class: "pt-2",
            modelValue: form.value.vehicle_inspection_information,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.vehicle_inspection_information) = $event)),
            "error-messages": errors.value.vehicle_inspection_information,
            disabled: isInstallationOffice.value,
            clearable: "",
            "onClick:clear": _cache[6] || (_cache[6] = ($event: any) => (clearFormField('vehicle_inspection_information')))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicles.form.vehicleInspectionInformation')) + " ", 1),
              _cache[20] || (_cache[20] = _createElementVNode("span", { style: {"color":"red"} }, [
                _createElementVNode("strong", null, "*")
              ], -1))
            ]),
            _: 1
          }, 8, ["modelValue", "error-messages", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_v_text_field, {
            class: "pt-2",
            modelValue: form.value.number_plate,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.number_plate) = $event)),
            "error-messages": errors.value.number_plate,
            disabled: isInstallationOffice.value,
            clearable: "",
            "onClick:clear": _cache[8] || (_cache[8] = ($event: any) => (clearFormField('number_plate')))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicles.numberPlate')) + " ", 1),
              _cache[21] || (_cache[21] = _createElementVNode("span", { style: {"color":"red"} }, [
                _createElementVNode("strong", null, "*")
              ], -1))
            ]),
            _: 1
          }, 8, ["modelValue", "error-messages", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_v_text_field, {
            class: "pt-2",
            label: _unref(i18n).global.t('pages.vehicles.registrationNumber'),
            modelValue: form.value.registration_number,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.registration_number) = $event)),
            disabled: isInstallationOffice.value,
            clearable: "",
            "onClick:clear": _cache[10] || (_cache[10] = ($event: any) => (clearFormField('registration_number')))
          }, null, 8, ["label", "modelValue", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_v_text_field, {
            class: "pt-2",
            label: _unref(i18n).global.t('pages.vehicles.form.mileageMeter'),
            modelValue: form.value.mileage_meter,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.mileage_meter) = $event)),
            "error-messages": errors.value.mileage_meter,
            clearable: "",
            "onClick:clear": _cache[12] || (_cache[12] = ($event: any) => (clearFormField('mileage_meter')))
          }, null, 8, ["label", "modelValue", "error-messages"])
        ]),
        _cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "col-1",
          style: {"position":"relative"}
        }, [
          _createElementVNode("p", { style: {"position":"absolute","bottom":"0px","margin":"0px"} }, "km")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          (loaded.value)
            ? (_openBlock(), _createBlock(DigitacoMappingAutoComplete, {
                key: 0,
                modelValue: form.value.digital_tacograph,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.digital_tacograph) = $event)),
                initialItemId: initialDigitacoMappingId.value,
                operationOffice: form.value.operationOffice,
                errorMessages: errors.value.digital_tacograph,
                readonly: isOperationOffice.value,
                disabled: isInstallationOffice.value,
                onClick: _cache[14] || (_cache[14] = ($event: any) => (isDigitacoMappingClicked.value = true))
              }, null, 8, ["modelValue", "initialItemId", "operationOffice", "errorMessages", "readonly", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (!isSelectedTeltonikaDevice.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (loaded.value)
                ? (_openBlock(), _createBlock(DigitalTacographFWCopyAutoComplete, {
                    key: 0,
                    modelValue: form.value.digital_tacograph_FW_copy,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.digital_tacograph_FW_copy) = $event)),
                    initialItemId: initialDigitalTacographFWCopyId.value,
                    operationOffice: form.value.operationOffice,
                    error: errors.value.digital_tacograph_FW_copy,
                    readonly: isOperationOffice.value,
                    disabled: isInstallationOffice.value
                  }, null, 8, ["modelValue", "initialItemId", "operationOffice", "error", "readonly", "disabled"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(DepartmentAutoComplete, {
            modelValue: form.value.department,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.department) = $event)),
            operationOffices: operationOffices.value,
            initialItemId: form.value.department_id,
            selectFirstIfOnlyOne: false,
            disabled: isInstallationOffice.value
          }, null, 8, ["modelValue", "operationOffices", "initialItemId", "disabled"])
        ])
      ]),
      (isManagementOffice.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("h6", _hoisted_26, _toDisplayString(_unref(i18n).global.t('pages.vehicles.form.isDailyReportJobDisabled')), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_v_switch, {
                  modelValue: form.value.is_daily_report_job_disabled,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.is_daily_report_job_disabled) = $event)),
                  color: "warning"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (form.value.is_daily_report_job_disabled)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 0,
                  type: "warning",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicles.form.dailyReportJobDisabledAlert')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (isDisplayIniFileSetting.value)
        ? (_openBlock(), _createBlock(IniFileSetting, {
            key: 3,
            item: form.value,
            initialModel: initialModel.value,
            selectedDevice: form.value.digital_tacograph,
            selectedOperationOffice: form.value?.operationOffice,
            selectedSimType: simType.value ?? undefined,
            selectedAccesspoint: accessPoint.value ?? undefined,
            modelValue: form.value.parameters,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.parameters) = $event)),
            errors: errors.value,
            selfOfficeType: selfOfficeType.value,
            vehicleForm: vehicleForm.value,
            isOperationOffice: isOperationOffice.value,
            isLatestStatus: isLatestStatus.value,
            sensorSetting: form.value.sensor_setting,
            isDigitacoMappingClicked: isDigitacoMappingClicked.value,
            parentLoaded: loaded.value,
            isInstallationOffice: isInstallationOffice.value,
            onChangeAccessPoint: changeAccessPoint,
            onChangeSimType: changeSimType,
            onChangeIsLatestStatus: changeIsLatestStatus,
            onUpdateConfigHash: updateConfigHash
          }, null, 8, ["item", "initialModel", "selectedDevice", "selectedOperationOffice", "selectedSimType", "selectedAccesspoint", "modelValue", "errors", "selfOfficeType", "vehicleForm", "isOperationOffice", "isLatestStatus", "sensorSetting", "isDigitacoMappingClicked", "parentLoaded", "isInstallationOffice"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(_component_router_link, { to: { name: 'Vehicle' } }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, { class: "ma-2 reset-btn" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (showableUpdateButton.value && isAuthority.value)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: "ma-2 exec-btn",
            onClick: submit,
            loading: running.value,
            disabled: hasItemError.value || hasError.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})